module.exports = __webpack_public_path__ + "img/img_ai_test_stock_card_bg@3x.1aa41d45.png";